<template>
  <transition name="Panel" appear>
    <div class="Panel">

      <router-link v-if="$root.orientation == 'landscape'" :to="{ name: 'chapters.' + lang, params: { chapter: $route.params.chapter } }" class="Panel__left" :style="{ backgroundImage: getGradient() }">
        <div class="ChaptersMenu__titles">
        <div class="ChaptersMenu__titles-rotate">
          <div v-if="chapter.index !== 0" class="ChaptersMenu__title is-1">{{ trans('Global.chapter') }} {{ chapter.index }}</div>
          <div class="ChaptersMenu__title is-2">{{ chapter[lang].title }}</div>
        </div>
        </div>
      </router-link>

      <VueFocusTrap class="Panel__right" ref="trap" @open="goFirst" @gofirst="goFirst" @golast="goLast">

        <button @click="close" ref="close" class="Panel__close"></button>

        <div class="Panel__content">
          <transition name="Page" mode="out-in">
            <comp :is="$route.meta.name" />
          </transition>
        </div>

        <div class="Panel__menu">
          <div class="Panel__menu-top">
            <button @click="$store.commit('app/SET_SUBTITLE', !subtitle)">
              <svg viewBox="0 0 29.74 26.73" v-if="!subtitle">
                <path class="cls-1" d="M19.79,1a9,9,0,0,1,9,8.94v6.44a9.36,9.36,0,0,1-9.35,9.35H9.94A9,9,0,0,1,1,16.79V9.94A9,9,0,0,1,9.94,1h9.85m0-1H9.94A9.94,9.94,0,0,0,0,9.94v6.85a9.94,9.94,0,0,0,9.94,9.94h9.45A10.35,10.35,0,0,0,29.74,16.38V9.94A10,10,0,0,0,19.79,0Z"/>
                <path class="cls-1" d="M7.06,13.37c0-3,1.3-5,3.84-5,2.3,0,3.26,1.51,3.4,3.35H12.42c-.11-1-.64-1.67-1.51-1.67h0c-1.18,0-1.94,1.25-1.94,3.35s.76,3.34,1.94,3.34h0c.87,0,1.37-.63,1.51-1.67H14.3c-.14,1.91-1.1,3.35-3.4,3.35C8.36,18.39,7.06,16.36,7.06,13.37Z"/>
                <path class="cls-1" d="M15.43,13.37c0-3,1.3-5,3.84-5,2.3,0,3.27,1.51,3.4,3.35H20.79c-.11-1-.64-1.67-1.5-1.67h0c-1.19,0-1.94,1.25-1.94,3.35s.75,3.34,1.94,3.34h0c.86,0,1.36-.63,1.5-1.67h1.88c-.13,1.91-1.1,3.35-3.4,3.35C16.73,18.39,15.43,16.36,15.43,13.37Z"/>
              </svg>
              <svg viewBox="0 0 29.73 26.73" v-if="subtitle">
                <rect class="cls-1" width="29.73" height="26.73" rx="10.35" ry="10.35"/>
                <path class="cls-2" d="M7.06,13.37c0-3,1.3-5,3.84-5,2.3,0,3.26,1.51,3.4,3.35H12.42c-.11-1-.64-1.67-1.51-1.67h0c-1.18,0-1.94,1.25-1.94,3.35s.76,3.34,1.94,3.34h0c.87,0,1.37-.63,1.51-1.67H14.3c-.14,1.91-1.1,3.35-3.4,3.35C8.36,18.39,7.06,16.36,7.06,13.37Z"/>
                <path class="cls-2" d="M15.43,13.37c0-3,1.3-5,3.84-5,2.3,0,3.27,1.51,3.4,3.35H20.79c-.11-1-.64-1.67-1.5-1.67h0c-1.19,0-1.94,1.25-1.94,3.35s.75,3.34,1.94,3.34h0c.86,0,1.36-.63,1.5-1.67h1.88c-.13,1.91-1.1,3.35-3.4,3.35C16.73,18.39,15.43,16.36,15.43,13.37Z"/>
              </svg>
            </button>
            <button @click="$root.langSwitch()" v-html="lang == 'fr' ? 'EN' : 'FR'" />
            <router-link :to="{ name: 'instructions.' + lang, params: { chapter: $route.params.chapter } }">?</router-link>
          </div>
          <div class="Panel__menu-middle">
            <router-link activeClass="is-active" :to="{ name: 'about.' + lang, params: { chapter: $route.params.chapter } }">{{ pages.about.admin[lang].title }}</router-link>
            <router-link activeClass="is-active" :to="{ name: 'team.' + lang, params: { chapter: $route.params.chapter } }">{{ pages.team.admin[lang].title }}</router-link>
            <router-link v-if="$root.orientation == 'portrait'" activeClass="is-active" :to="{ name: 'instructions.' + lang, params: { chapter: $route.params.chapter } }">?</router-link>
          </div>
          <div class="Panel__menu-bottom" v-if="$root.orientation == 'landscape'">
            <button class="Panel__share" @click="share('facebook')">
              <svg viewBox="0 0 20.934 20.934">
                <path class="cls-1" d="M19.771,0H1.163A1.163,1.163,0,0,0,0,1.163V19.771a1.163,1.163,0,0,0,1.163,1.163H11.182V12.839H8.464V9.67h2.718V7.344a3.808,3.808,0,0,1,4.07-4.175,22.521,22.521,0,0,1,2.436.125V6.106H16.014c-1.308,0-1.561.622-1.561,1.538V9.661H17.59l-.407,3.169h-2.73v8.1h5.318a1.163,1.163,0,0,0,1.163-1.163V1.163A1.163,1.163,0,0,0,19.771,0Z" />
              </svg>
            </button>
            <button class="Panel__share" @click="share('twitter')">
              <svg viewBox="0 0 24.284 19.851">
                <path d="M0,17.534A14.164,14.164,0,0,0,21.8,4.95a10.036,10.036,0,0,0,2.48-2.572,9.856,9.856,0,0,1-2.851.775A4.929,4.929,0,0,0,23.617.394a10.165,10.165,0,0,1-3.1,1.224,4.99,4.99,0,0,0-8.554,4.618A14.243,14.243,0,0,1,1.689.952,4.975,4.975,0,0,0,3.239,7.6a5.053,5.053,0,0,1-2.263-.62,4.975,4.975,0,0,0,4,4.944,4.96,4.96,0,0,1-2.247.093,4.974,4.974,0,0,0,4.649,3.456A10.011,10.011,0,0,1,0,17.534Z" transform="translate(0 0.069)"/>
              </svg>
            </button>
          </div>
        </div>
      </VueFocusTrap>

      <NavMobile v-if="$route.meta.name == 'menu'" />

    </div>
  </transition>
</template>

<script>
import About from '@/pages/about/About'
import Team from '@/pages/team/Team'
import Instructions from '@/pages/instructions/Instructions'
import NavMobile from '@/components/nav-mobile/NavMobile'
import { VueFocusTrap } from "vue-a11y-utils"

export default {
  name: 'Panel',
  components: { About, Team, Instructions, NavMobile, VueFocusTrap },
  computed: {
    subtitle() { return this.$store.getters['app/subtitle'] },
    pages() { return this.$store.getters['data/pages'] },
  },
  created() {
    this.chapter = _.find(this.chapters, chapter => chapter[this.lang].slug == this.$route.params.chapter )
  },
  beforeDestroy() {
    this.$refs.trap.close(true)
  },
  mounted() {
    setTimeout(() => {
      this.$refs.trap.open()


      console.log(this.$refs.trap);

    }, 500)
  },
  methods: {
    close() {
      const menu = this.$root.orientation == 'portrait' ? 'menu.' + this.lang : 'about.' + this.lang
      this.$router.push({
        name: this.$route.meta.name == 'chapters' ? menu : 'chapters.' + this.lang,
        params: this.$route.params
      })
    },
    goFirst() {
      this.$refs.close.focus()
    },
    goLast() {
      this.$refs.close.focus()
    },
    getGradient() {
      return `linear-gradient(to bottom, ${this.chapter.colors.primary}, ${this.chapter.colors.secondary})`
    },
    share(type) {
      let currentUrl = window.location.href
      const w = 550
      const h = 450
      const dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left
      const dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top
      const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width
      const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height
      const left = ((width / 2) - (w / 2)) + dualScreenLeft
      const top = ((height / 2) - (h / 2)) + dualScreenTop
      const urls = {
        'facebook': 'https://www.facebook.com/sharer/sharer.php?u=',
        'twitter': 'https://twitter.com/share?url=',
      }
		  const url = urls[type] + encodeURI(currentUrl)
      const newWindow = window.open(url, '', 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
      if(newWindow && newWindow.focus)
        newWindow.focus()
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Panel
  z-index 9
  position absolute
  top 0
  left 0
  width 100%
  height 100%
  transition opacity 1s, transform 1s
  display flex
  &-enter
  &-leave-active
    +portrait()
      opacity 0
    +landscape()
      .Panel__left
        transform translateX(-20vw)
      .Panel__right
        transform translateX(80vw)

  &__right
  &__left
    transition transform 1s
    position relative

  &__right
    background purple
    width 80vw
    display flex
    +portrait()
      width 100vw
      flex-direction column

  button.Panel__close
    position absolute
    right 15px
    top 15px
    width 45px
    height 36px
    padding 0
    margin 0

  &__left
    width 20vw
    cursor pointer

  &__content
    width 60vw
    position relative
    height 100%
    +portrait()
      width 100vw

  &__menu
    width 20vw
    background-image linear-gradient(to top, purple, rgba(white, .05))
    height 100%
    padding 25px
    box-sizing border-box
    display flex
    flex-direction column
    justify-content space-between
    +portrait()
      order -1
      width 100vw
      flex-direction row
      height auto
      padding 25px 10px
      background purple
    &-top
      display flex
      align-items center
      svg
        fill white
        position relative
        .cls-1
          fill #fff
        .cls-2
          fill #552084
      button
      div
        width 30px
        height 20px
        margin-right 20px
        line-height 20px
        cursor pointer
        font-weight 500
        color white
      a
        position relative
        text-decoration none
        display block
        top 2px
      +portrait()
        display none
    &-middle
      display flex
      align-items flex-end
      flex-direction column
      font-size 20px
      font-weight 900
      +portrait()
        flex-direction row
        font-size 16px
      a
        margin 10px 0
        display block
        text-decoration none
        position relative
        +portrait()
          margin 0px 10px
        &:after
          content ''
          height 3px
          position Absolute
          width 100%
          bottom -3px
          transform scaleX(0)
          transform-origin right top
          transition transform .5s
          background white
          left 0
        &.is-active
          &:after
            transform scaleX(1)
    &-bottom
      display flex
      justify-content flex-end
      svg
        fill white

  &__share
    display block
    width 20px
    height 20px
    margin-left 20px
    cursor pointer
    padding 0



</style>
